<template>
  <div class="OATable">
    <OAHeader v-if="filterData" :form-data="filterData" @search="handleSearch">
      <slot name="header"></slot>
    </OAHeader>
    <OACard>
      <slot name="button"></slot>
      <d2-crud ref="d2Crud" :columns="columns" :data="tableData" :options="options"
        :selection-row="selectionRow?{fixed:true}:null" @selection-change="handleSelectionChange" :loading="loading"
        @sort-change="handleSortChange" :pagination="pagination" @pagination-size-change="handleSizeChange"
        @pagination-current-change="handleCurrentChange" @cell-data-change="handleCellDataChange"
        @cell-click="cellClick" />
    </OACard>
  </div>
</template>
<script>
  import d2Crud from "@d2-projects/d2-crud";
  import OAHeader from "./OAHeader";
  import OACard from "@/components/OACard/OACard";

  export default {
    name: "OATable",
    components: {
      d2Crud,
      OAHeader,
      OACard
    },
    props: {
      filterData: {
        default: null
      },
      data: {
        default: null
      },
      columns: {
        default: null
      },
      selectionRow: {
        default: false
      },
      pageSizes: {
        default: 10
      },
      loading: {
        default: false
      }
    },
    data() {
      return {
        tableData: [],
        options: {
          border: true,
          stripe: true,
          size: "medium"
        },
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0,
          layout: "total,sizes,prev,pager,next",
          pageSizes: [10, 20, 50, 100]
        },
        param: {},
        sort: {}
      };
    },
    watch: {
      data: {
        handler: function (val, oldVal) {
          if (val && val.data && val.page) {
            this.tableData = val.data;
            this.pagination.total = val.page.totalRecords;
          }
        },
        deep: true,
        immediate: true
      },
      pageSizes: {
        handler: function (val, oldVal) {
          if (val && val.length) {
            this.pagination.pageSizes = val;
            this.pagination.pageSize = val[0];
          }
        },
        deep: true,
        immediate: true
      }
    },
    mounted() {
      this.handleSearch(this.param);
    },
    methods: {
      async handleSearch(val) {
        this.pagination.currentPage = _.isEqual(this.param, val) ?
          this.pagination.currentPage :
          1;
        this.param = val;
        this.$emit("search", {
          ...this.param,
          ...this.sort,
          displayLength: this.pagination.pageSize,
          displayStart: this.pagination.currentPage
        });
      },
      handleSizeChange(val) {
        this.pagination.pageSize = val;
        this.handleSearch(this.param);
      },
      handleCurrentChange(val) {
        this.pagination.currentPage = val;
        this.handleSearch(this.param);
      },
      handleSelectionChange(selection) {
        this.$emit("selectionChange", selection);
      },
      handleCellDataChange(val) {
        this.$emit("cellDataChange", val);
      },
      cellClick(row, column, cell, event) {
        this.$emit("cellClick", {
          row,
          column,
          cell,
          event
        });
      },
      handleSortChange(val) {
        this.sort = {
          sortType: val.order,
          sortName: val.prop
        };
        this.$emit("search", {
          ...this.param,
          ...this.sort,
          displayLength: this.pagination.pageSize,
          displayStart: this.pagination.currentPage
        });
      }
    }
  };

</script>
<style lang="scss">
  .OATable {

    /*操作栏*/
    .handle {
      color: #409eff;
      cursor: pointer;
    }

    .normal {
      color: #909399;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/OATable/OATable.vue